export const ConfidenceBadge = ({ value, testId }) => {
  const v = Math.max(0, Math.min(100, Number(value) || 0));
  let bg = "rgba(239, 68, 68, 0.15)";
  let border = "#ef4444";
  let color = "#ef4444";
  if (v >= 75) { bg = "rgba(16, 185, 129, 0.15)"; border = "#10b981"; color = "#10b981"; }
  else if (v >= 50) { bg = "rgba(245, 158, 11, 0.15)"; border = "#f59e0b"; color = "#f59e0b"; }

  return (
    <span
      data-testid={testId}
      className="inline-flex items-center justify-center min-w-[46px] px-2 py-0.5 rounded-full text-[11px] font-mono font-semibold border"
      style={{ background: bg, borderColor: border, color }}
    >
      {v}
    </span>
  );
};

export const DirectionBadge = ({ direction, testId }) => {
  const isBuy = direction === "BUY";
  const color = isBuy ? "#10b981" : "#ef4444";
  const bg = isBuy ? "rgba(16, 185, 129, 0.15)" : "rgba(239, 68, 68, 0.15)";
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-mono font-bold border"
      style={{ background: bg, borderColor: color, color }}
    >
      {direction}
    </span>
  );
};

export const StatusBadge = ({ status, testId }) => {
  const map = {
    pending: { c: "#f59e0b", b: "rgba(245, 158, 11, 0.15)" },
    consumed: { c: "#6b7280", b: "rgba(107, 114, 128, 0.15)" },
    expired: { c: "#4b5563", b: "rgba(75, 85, 99, 0.15)" },
  };
  const s = map[status] || map.consumed;
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] uppercase tracking-wider font-semibold border"
      style={{ background: s.b, borderColor: s.c, color: s.c }}
    >
      {status}
    </span>
  );
};
